import { ReactElement, RefObject } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PostListItem, ReactionStats } from 'api';
import { useCompanyDetails } from 'components/Dialogs/hooks';
import { PostTopBar } from 'components/PostTopBar';
import { ReactionsWrapper } from 'components/ReactionsWrapper';
import { usePostDetailsPage } from 'features/postDetails/containers/PostDetailsPage/usePostDetailsPage';
import { InViewItemRef } from 'types';

import { PollResults } from '../PollResults';
import { LeftSide, PostContentWrapper, PostTitle, PostW, StrongW } from '../styled';
import { PollDescription, Container } from './styled';

interface PollPostProps {
  id: string;
  author: PostListItem['author'];
  authorName: string;
  publishedAt: string;
  reactions?: ReactionStats;
  comments_count?: number;
  postRef: RefObject<HTMLDivElement>;
  lastItemRef?: InViewItemRef;
  handlePostClick?: () => void;
  handleOpenReactionModal?: () => void;
  isSlider?: boolean;
}

export function PollPost({
  id,
  author,
  authorName,
  publishedAt,
  reactions,
  comments_count,
  postRef,
  lastItemRef,
  handlePostClick,
  handleOpenReactionModal,
  isSlider,
}: PollPostProps): ReactElement {
  const { t } = useTranslation();
  const { post } = usePostDetailsPage(id);
  const options = post?.poll?.options || [];
  const { company } = useCompanyDetails();

  return (
    <Container ref={postRef}>
      <PostW ref={lastItemRef} isAutomatedPost isSlider={isSlider}>
        <PostContentWrapper>
          <PostTopBar
            id={id}
            publishedAt={publishedAt}
            postTitle={t('post.listItem.birthdayPost.title', {
              user: authorName,
            })}
            authorName={company?.name || ''}
            author={author}
            isAutomatedPost
            isPoll
          />
          <LeftSide>
            <PostTitle>
              <Trans
                i18nKey="post.listItem.pollPost.titleFormatted"
                values={{
                  title: post?.title,
                }}
              >
                The poll &quot;<StrongW>{post?.title}</StrongW>&quot; is finished!
              </Trans>
            </PostTitle>
            <PollDescription>
              <div>{t('post.listItem.pollPost.description')}</div>
            </PollDescription>

            <PollResults options={options} />
          </LeftSide>
        </PostContentWrapper>
        <ReactionsWrapper
          id={id}
          isPreview={false}
          reactions={reactions}
          comments_count={comments_count}
          handlePostClick={handlePostClick}
          handleOpenReactionModal={handleOpenReactionModal}
        />
      </PostW>
    </Container>
  );
}
